export const syncViewportMeta = (viewportContent: string | undefined): void => {
    const existingMeta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');

    if (!viewportContent) {
        existingMeta?.remove();

        return;
    }

    if (existingMeta) {
        existingMeta.content = viewportContent;

        return;
    }

    const meta = document.createElement('meta');

    meta.name = 'viewport';
    meta.content = viewportContent;
    document.head.appendChild(meta);
};
